// store/thunks/auth/verify2faCodeThunk.ts

import { MIN_LEN } from "@/constants";
import { createAdminAsyncThunk } from "@/store/thunks/createAdminAsyncThunk";
import { sessionExpired } from "@/store/slices/auth/authSlice";
import type { FinalizeVerifyDTO } from "@/types/dtos.types";
import { isJWTExpired } from "@/utils/jwtDecoder";
import { setSessionToken } from "@/utils/sessionStorage";

import { withLoader } from "../thunkWrappers";

export const verify2faCodeThunk = createAdminAsyncThunk<
  FinalizeVerifyDTO,
  { code: string },
  { rejectValue: { message: string } }
>('auth/verify2faCode',withLoader( async({ code }, { getState, dispatch, extra: { authService }, rejectWithValue }) => {
  const { auth } = getState();
  const { regToken: twoFactorToken, twoFactorMethod: method } = auth;

  if (twoFactorToken === undefined || twoFactorToken.trim().length === MIN_LEN) {
    return rejectWithValue({ message: 'Missing two-factor token' });
  }

  if (isJWTExpired(twoFactorToken)) {
    dispatch(sessionExpired());
    return rejectWithValue({ message: 'Session Expired. Please Login Again.' });
  }

  try {
    const result = await authService.verifyTwoFactorCode({
      code,
      twoFactorToken,
      method,
    });
    setSessionToken(result.sessionToken);
    return result;
  } catch (caught) {
    const message = caught instanceof Error ? caught.message : 'Failed to verify 2FA code';
    return rejectWithValue({ message });
  }
}));

